import { ReactElement, useState } from 'react';
import { Modal, TextLink, Tooltip } from '@bfe/moly';
import { useFm } from '@web3/base-hooks';
import { initialWindowType } from '@/hooks/media';

import styles from './index.module.scss';

type Props = {
  show: boolean;
  onClose: () => void;
};

export const NotAdvancedModal = (props: Props) => {
  const { show, onClose } = props;
  const { isMobile } = initialWindowType;
  const fm = useFm();

  const unPromotedProjects = [
    {
      week: '1',
      time: '2024-10-08 10:00 UTC',
      count: '5',
    },
    {
      week: '2',
      time: '2024-10-15 10:00 UTC',
      count: '5',
    },
    {
      week: '3',
      time: '2024-10-22 10:00 UTC',
      count: '5',
    },
  ];

  return (
    <>
      <Modal
        isMobile={isMobile}
        direction={!isMobile ? 'center' : 'bottom'}
        title={fm('whatIsNotAdvanced')}
        okText={fm('i_know')}
        cancelText={false}
        onCancel={() => {
          onClose();
        }}
        onOk={() => {
          onClose();
        }}
        open={show}
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        <div className={styles.wrapper}>
          <ul>
            <li>
              {fm('weeklyBottomProjects', {
                amount: '5',
              })}
            </li>
            <li>{fm('supportersPointsLocked')}</li>
          </ul>
          <div className={styles.tableWrapper}>
            <div className={styles.tableTitle}>{fm('tradeScoreLevel')}</div>
            <div className={styles.table}>
              <div className={styles.theader}>
                <div className={styles.td}>{fm('week')}</div>
                <div className={styles.td}>{fm('time')}</div>
                <div className={styles.td}>{fm('notAdvanced')}</div>
              </div>
              <div className={styles.tbody}>
                {unPromotedProjects.map((item, index) => (
                  <div key={index} className={styles.tr}>
                    <div className={styles.td}>{item.week}</div>
                    <div className={styles.td}>{item.time}</div>
                    <div className={styles.td}>{item.count}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};
